/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import { setupAxios } from "./app/utils/setupAxios";

import store, { persistor } from "./app/store/store";
import App from "./App";
import { initVersionCheck } from "./app/utils/versionCheck";
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

/**
 * Inject axios interceptors for auth token management.
 */
setupAxios(axios, store);

// Initialize version checking to prevent cached old UI/UX
initVersionCheck();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <App
    store={store}
    persistor={persistor}
    basename={PUBLIC_URL}
  />
);
